/**
 * Historial de cambios orientado al usuario (Registro de Cambios).
 *
 * Versión "amigable" del CHANGELOG.md del proyecto: describe los avances,
 * mejoras y correcciones del sistema en lenguaje claro, sin detalles técnicos,
 * de código ni información privada. Cada entrada corresponde a una versión
 * publicada, ordenada de la más reciente a la más antigua.
 *
 * Tipos de cambio: 'nuevo' (funcionalidad nueva), 'mejora' (optimización o
 * cambio de experiencia) y 'correccion' (arreglo de un problema).
 *
 * Las fechas se guardan en formato ISO (YYYY-MM-DD) y se muestran con formato
 * legible en el componente.
 */

export default [
  {
    version: '0.8.34',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Nueva sección "Registro de Cambios": una línea de tiempo con la historia de avances, mejoras y correcciones del sistema.' }
    ]
  },
  {
    version: '0.8.33',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Reorganización del menú lateral: "Registros de Acceso" queda bajo "Socios y Membresías", y este último se renombró para una lectura más natural.' }
    ]
  },
  {
    version: '0.8.32',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'En las métricas de acceso ahora puedes descargar cada gráfico en pantalla completa como PDF o como imagen, con su tabla de datos incluida.' }
    ]
  },
  {
    version: '0.8.31',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Las tablas de los gráficos ampliados muestran filas con tonos intercalados para una lectura más cómoda.' }
    ]
  },
  {
    version: '0.8.30',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Las tablas de datos de los gráficos ahora incluyen el porcentaje de cada valor sobre el total y una fila de totales para cuadrar las cifras.' }
    ]
  },
  {
    version: '0.8.29',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Cada gráfico de las métricas de acceso puede verse en pantalla completa, junto con la tabla detallada de los datos que lo componen.' }
    ]
  },
  {
    version: '0.8.28',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Los gráficos de las métricas muestran los valores numéricos directamente, sin necesidad de pasar el cursor por encima.' }
    ]
  },
  {
    version: '0.8.27',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Ajuste automático del tamaño del texto en las tarjetas de métricas para que los nombres largos se vean completos en una sola línea.' }
    ]
  },
  {
    version: '0.8.26',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Las tarjetas "Método más usado" y "Plan más usado" ahora son más amplias para mostrar mejor su contenido.' }
    ]
  },
  {
    version: '0.8.25',
    date: '2026-05-22',
    items: [
      { type: 'correccion', text: 'Se corrigió la posición de los datos al exportar los registros de acceso a Excel.' }
    ]
  },
  {
    version: '0.8.24',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Ahora puedes exportar a Excel todos los registros de acceso filtrados, con un proceso de descarga que muestra su progreso.' }
    ]
  },
  {
    version: '0.8.23',
    date: '2026-05-22',
    items: [
      { type: 'mejora', text: 'Se mejoró el texto de ejemplo del buscador de registros de acceso.' }
    ]
  },
  {
    version: '0.8.22',
    date: '2026-05-22',
    items: [
      { type: 'correccion', text: 'Los indicadores de carga ahora muestran únicamente el ícono giratorio, sin texto adicional.' }
    ]
  },
  {
    version: '0.8.21',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Nueva pestaña "Personas" en Registros de Acceso: resumen por persona con sus ingresos, salidas, primer y último acceso, sucursales, planes y métodos utilizados.' }
    ]
  },
  {
    version: '0.8.20',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Nueva pestaña "Registros" con el listado detallado y paginado de cada acceso, ordenable y con vista de detalle.' }
    ]
  },
  {
    version: '0.8.19',
    date: '2026-05-22',
    items: [
      { type: 'nuevo', text: 'Nuevo módulo "Registros de Acceso": analiza el movimiento de personas por los puntos de acceso del recinto con indicadores y gráficos (por hora, día, método, sucursal, plan y más).' }
    ]
  },
  {
    version: '0.8.18',
    date: '2026-05-01',
    items: [
      { type: 'correccion', text: 'Se corrigió un problema que afectaba el inicio de sesión y el guardado de los datos del usuario.' }
    ]
  },
  {
    version: '0.8.17',
    date: '2026-05-01',
    items: [
      { type: 'mejora', text: 'La opción "Puntos de Acceso" quedó disponible solo para el perfil de Soporte, ya que está en evolución.' }
    ]
  },
  {
    version: '0.8.16',
    date: '2026-05-01',
    items: [
      { type: 'nuevo', text: 'Nuevo proceso automático configurable: activación de membresías secundarias cuando la principal está vencida o pendiente.' }
    ]
  },
  {
    version: '0.8.15',
    date: '2026-05-01',
    items: [
      { type: 'mejora', text: 'Se ocultó temporalmente "Actualizador Masivo" mientras se trabaja en su nueva versión.' }
    ]
  },
  {
    version: '0.8.14',
    date: '2026-05-01',
    items: [
      { type: 'mejora', text: 'Se ocultó el menú "Herramientas" (Constructor de Correos, Conectores y WhatsApp Web) por estar aún en desarrollo.' }
    ]
  },
  {
    version: '0.8.13',
    date: '2026-05-01',
    items: [
      { type: 'mejora', text: 'El módulo de Agendamiento se retiró del panel para preparar su futura incorporación como módulo opcional dentro de un catálogo de módulos.' }
    ]
  },
  {
    version: '0.8.12',
    date: '2026-04-30',
    items: [
      { type: 'nuevo', text: 'Nuevo proceso automático: notificación de vencimientos a los socios, con configuración de los días de aviso por gimnasio.' }
    ]
  },
  {
    version: '0.8.11',
    date: '2026-04-30',
    items: [
      { type: 'nuevo', text: 'Nuevo módulo "Procesos Automáticos": cada gimnasio puede activar, desactivar y configurar la normalización automática de membresías.' }
    ]
  },
  {
    version: '0.8.10',
    date: '2026-04-28',
    items: [
      { type: 'nuevo', text: 'Ahora se pueden asignar nuevas membresías (principales y adicionales) desde "Gestión de Membresías", completando todo el ciclo de administración.' }
    ]
  },
  {
    version: '0.8.9',
    date: '2026-04-28',
    items: [
      { type: 'nuevo', text: 'Posibilidad de eliminar membresías activas y adicionales desde "Gestión de Membresías".' }
    ]
  },
  {
    version: '0.8.8',
    date: '2026-04-28',
    items: [
      { type: 'mejora', text: 'El editor de membresías permite modificar más campos: familia, subfamilia, descripción del plan y turno asignado.' }
    ]
  },
  {
    version: '0.8.7',
    date: '2026-04-27',
    items: [
      { type: 'nuevo', text: 'Edición individual de membresías principales y secundarias desde "Gestión de Membresías".' }
    ]
  },
  {
    version: '0.8.6',
    date: '2026-04-26',
    items: [
      { type: 'nuevo', text: 'Nueva vista "Gestión de Membresías" para administrar de forma individual las membresías activas y adicionales de cada socio.' }
    ]
  },
  {
    version: '0.8.5',
    date: '2026-04-20',
    items: [
      { type: 'mejora', text: 'Actualización de la documentación interna del proyecto.' }
    ]
  },
  {
    version: '0.8.4',
    date: '2026-01-08',
    items: [
      { type: 'correccion', text: 'Se corrigió un problema en el formulario público de sugerencias para socios.' }
    ]
  },
  {
    version: '0.8.3',
    date: '2026-01-08',
    items: [
      { type: 'mejora', text: 'Mejoras en el sistema de sugerencias.' }
    ]
  },
  {
    version: '0.8.2',
    date: '2026-01-08',
    items: [
      { type: 'correccion', text: 'Correcciones menores de estabilidad.' }
    ]
  },
  {
    version: '0.8.1',
    date: '2026-01-08',
    items: [
      { type: 'correccion', text: 'Correcciones menores de estabilidad.' }
    ]
  },
  {
    version: '0.8.0',
    date: '2026-01-08',
    items: [
      { type: 'nuevo', text: 'Nuevo sistema de Sugerencias Públicas: los socios sin app móvil pueden enviar sus sugerencias desde la web.' }
    ]
  },
  {
    version: '0.7.10',
    date: '2026-01-08',
    items: [
      { type: 'mejora', text: 'Las sugerencias ahora distinguen su origen (app móvil o web pública) y muestran información adicional según el caso.' }
    ]
  },
  {
    version: '0.7.9',
    date: '2026-01-08',
    items: [
      { type: 'nuevo', text: 'Nuevo módulo de Gestión de Sugerencias: panel con métricas, filtros, detalle y respuesta a las sugerencias, felicitaciones y reclamos de los socios.' },
      { type: 'correccion', text: 'Varias correcciones de comunicación y visualización en el módulo de sugerencias.' }
    ]
  },
  {
    version: '0.7.8',
    date: '2025-11-10',
    items: [
      { type: 'correccion', text: 'Se corrigió la preselección de familia y subfamilia al crear planes.' }
    ]
  },
  {
    version: '0.7.7',
    date: '2025-11-03',
    items: [
      { type: 'mejora', text: 'Mejoras en la gestión de planes.' }
    ]
  },
  {
    version: '0.7.6',
    date: '2025-11-03',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.7.5',
    date: '2025-10-29',
    items: [
      { type: 'mejora', text: 'Nuevas mejoras y correcciones en planes y ventas.' }
    ]
  },
  {
    version: '0.7.4',
    date: '2025-10-29',
    items: [
      { type: 'correccion', text: 'Correcciones menores.' }
    ]
  },
  {
    version: '0.7.3',
    date: '2025-10-29',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.7.2',
    date: '2025-10-28',
    items: [
      { type: 'correccion', text: 'Correcciones menores.' }
    ]
  },
  {
    version: '0.7.1',
    date: '2025-10-28',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.7.0',
    date: '2025-10-28',
    items: [
      { type: 'mejora', text: 'Mejoras generales del panel.' }
    ]
  },
  {
    version: '0.6.9',
    date: '2025-10-28',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en los módulos de gestión.' }
    ]
  },
  {
    version: '0.6.8',
    date: '2025-10-21',
    items: [
      { type: 'correccion', text: 'Correcciones de estabilidad.' }
    ]
  },
  {
    version: '0.6.7',
    date: '2025-10-21',
    items: [
      { type: 'correccion', text: 'Correcciones de estabilidad.' }
    ]
  },
  {
    version: '0.6.6',
    date: '2025-10-21',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.6.5',
    date: '2025-10-21',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.6.4',
    date: '2025-10-21',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en el panel de administración.' }
    ]
  },
  {
    version: '0.6.3',
    date: '2025-10-21',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en el panel de administración.' }
    ]
  },
  {
    version: '0.6.2',
    date: '2025-10-21',
    items: [
      { type: 'mejora', text: 'Ajustes y mejoras internas.' }
    ]
  },
  {
    version: '0.6.1',
    date: '2025-10-20',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en el panel de administración.' }
    ]
  },
  {
    version: '0.6.0',
    date: '2025-10-03',
    items: [
      { type: 'nuevo', text: 'Gran actualización: nuevos módulos de gestión con tarjetas de indicadores (KPIs), filtros, búsqueda y paginación, con diseño adaptable a móvil, tablet y escritorio.' }
    ]
  },
  {
    version: '0.5.8',
    date: '2025-10-03',
    items: [
      { type: 'mejora', text: 'Rediseño y mejoras en la gestión de socios y membresías, con mejor experiencia en dispositivos móviles.' }
    ]
  },
  {
    version: '0.5.7',
    date: '2025-09-28',
    items: [
      { type: 'mejora', text: 'La gestión de membresías se integró dentro de "Gestión de Socios" para un acceso más rápido y directo.' }
    ]
  },
  {
    version: '0.5.6',
    date: '2025-01-11',
    items: [
      { type: 'mejora', text: 'Se permite cambiar la sucursal de origen al editar un socio y mejor legibilidad en los formularios.' }
    ]
  },
  {
    version: '0.5.5',
    date: '2024-12-23',
    items: [
      { type: 'nuevo', text: 'Nuevas métricas de socios: distribución por estado de cuenta, perfil, género, edad y región, con gráficos visuales.' },
      { type: 'mejora', text: 'Mejoras visuales en las estadísticas, credenciales de acceso y formularios de socios.' }
    ]
  },
  {
    version: '0.5.4',
    date: '2024-12-22',
    items: [
      { type: 'nuevo', text: 'Tabla de socios enriquecida: plan y estado, vencimiento con días restantes, consumo de sesiones y credenciales de acceso.' }
    ]
  },
  {
    version: '0.5.3',
    date: '2024-12-22',
    items: [
      { type: 'mejora', text: 'Mejoras y correcciones en la gestión de socios.' }
    ]
  },
  {
    version: '0.5.2',
    date: '2024-12-17',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en la administración de socios.' }
    ]
  },
  {
    version: '0.5.1',
    date: '2024-12-17',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en la administración de socios.' }
    ]
  },
  {
    version: '0.5.0',
    date: '2024-12-16',
    items: [
      { type: 'nuevo', text: 'Captura de foto de socio y reconocimiento facial, con una interfaz renovada.' }
    ]
  },
  {
    version: '0.4.9',
    date: '2024-12-16',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en la gestión de socios.' }
    ]
  },
  {
    version: '0.4.8',
    date: '2024-12-16',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades en la gestión de socios.' }
    ]
  },
  {
    version: '0.4.5',
    date: '2024-12-16',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades y mejoras del panel.' }
    ]
  },
  {
    version: '0.4.4',
    date: '2024-10-28',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades del panel de administración.' }
    ]
  },
  {
    version: '0.4.3',
    date: '2024-10-07',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades del panel de administración.' }
    ]
  },
  {
    version: '0.4.2',
    date: '2024-08-22',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades del panel de administración.' }
    ]
  },
  {
    version: '0.4.1',
    date: '2024-08-13',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades del panel de administración.' }
    ]
  },
  {
    version: '0.4.0',
    date: '2024-08-08',
    items: [
      { type: 'nuevo', text: 'Nuevas funcionalidades y correcciones del panel.' }
    ]
  },
  {
    version: '0.3.2',
    date: '2024-07-25',
    items: [
      { type: 'mejora', text: 'Mejoras en la creación de planes y validación de campos; correcciones en cierres de caja y membresías.' }
    ]
  },
  {
    version: '0.3.1',
    date: '2024-06-19',
    items: [
      { type: 'mejora', text: 'Mejoras y correcciones generales.' }
    ]
  },
  {
    version: '0.3.0',
    date: '2024-06-18',
    items: [
      { type: 'mejora', text: 'Mejoras y correcciones en planes, cierres de caja y membresías.' }
    ]
  },
  {
    version: '0.2.5',
    date: '2024-05-28',
    items: [
      { type: 'correccion', text: 'Correcciones en el reporte de registro de personas y en el filtrado de membresías.' }
    ]
  },
  {
    version: '0.2.4',
    date: '2024-05-22',
    items: [
      { type: 'nuevo', text: 'Filtro por rango de fechas en el historial de membresías y mejoras en su visualización.' }
    ]
  },
  {
    version: '0.2.3',
    date: '2024-05-10',
    items: [
      { type: 'nuevo', text: 'Filtro por caja en el panel de ventas y primera versión del visor de historial de membresías.' }
    ]
  },
  {
    version: '0.2.2',
    date: '2024-04-29',
    items: [
      { type: 'nuevo', text: 'Configuración del punto de venta, cambio de contraseña en el primer ingreso y manejo de multisede en socios.' }
    ]
  },
  {
    version: '0.2.1',
    date: '2024-04-17',
    items: [
      { type: 'mejora', text: 'Mejoras en la experiencia de bienvenida y correcciones de visualización en móvil y exportaciones.' }
    ]
  },
  {
    version: '0.2.0',
    date: '2024-04-05',
    items: [
      { type: 'nuevo', text: 'Creación, modificación y eliminación de socios desde el panel.' }
    ]
  },
  {
    version: '0.1.3',
    date: '2024-03-20',
    items: [
      { type: 'nuevo', text: 'Posibilidad de desasociar (eliminar) membresías existentes.' }
    ]
  },
  {
    version: '0.1.2',
    date: '2024-03-01',
    items: [
      { type: 'mejora', text: 'Mejoras y correcciones generales.' }
    ]
  },
  {
    version: '0.1.1',
    date: '2024-02-28',
    items: [
      { type: 'mejora', text: 'Versión Beta: mejoras y correcciones iniciales.' }
    ]
  },
  {
    version: '0.1.0',
    date: '2024-02-23',
    items: [
      { type: 'nuevo', text: 'Versión Beta inicial del panel de administración.' }
    ]
  },
  {
    version: '0.0.2',
    date: '2024-02-12',
    items: [
      { type: 'mejora', text: 'Primeras mejoras y correcciones del sistema.' }
    ]
  },
  {
    version: '0.0.1',
    date: '2024-02-05',
    items: [
      { type: 'mejora', text: 'Ajustes iniciales del sistema.' }
    ]
  },
  {
    version: '0.0.0',
    date: '2024-01-10',
    items: [
      { type: 'nuevo', text: 'Inicio del proyecto: base del panel de administración de CentralGym.' }
    ]
  }
];
